import { render, staticRenderFns } from "./TagEditAction.vue?vue&type=template&id=ebf84d88"
import script from "./TagEditAction.vue?vue&type=script&lang=js"
export * from "./TagEditAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports